import type {PointerEvent, ReactElement} from 'react';
import type {GridItemStorage} from '@Components/base-grid/components/grid-item';
import type {IconSize} from '@Components/icon-v2/icon.types';

export enum CarouselDirection {
  HORIZONTAL,
  VERTICAL,
}

export enum CarouselClickBehaviour {
  ADD = 'add',
  SELECT = 'select',
}

export interface CarouselItemData {
  width: number;
  height: number;
  /** The width is a fixed card width (audio / voice / CTA cards) — exempt from maxItemAspectRatio clamping. */
  hasFixedWidth?: boolean;
  gridItemData: GridItemStorage;
}

export interface CarouselProps {
  items: CarouselItemData[];
  onNext?: () => void;
  onPrev?: () => void;
  height?: number;
  selectionGroupId?: string;
  maxSelectionNumber?: number;
  onSingleItemClick?: (items: GridItemStorage[]) => Promise<void>;
  onCarouselItemClicked?: (carouselItemID: string) => void;
  clickBehaviour?: CarouselClickBehaviour;
  isItemDraggable?: boolean;
  onItemPointerDown?: (item: GridItemStorage, e: PointerEvent<HTMLElement>) => void;
  getTopRightContentForGridItem?: (item: GridItemStorage) => ReactElement | null;
  nextBtnRightPositioning?: number;
  prevBtnLeftPositioning?: number;
  gridID?: string;
  controlButtonIconSize?: IconSize;
  controlButtonTopPositioning?: number;
  /** Caps tile width at height × this ratio; a clamped item's media letterboxes inside the tile instead of cover-cropping. */
  maxItemAspectRatio?: number;
  // CodeReviewSarimDone: still 2 props + 2 exported css var consts + a data-can-scroll-prev attr on the shared Carousel for one row, and the row scss already reaches into carousel internals (.templateRowTrack > ul, ~ div), so the "wrapper class would target internals" reason doesn't hold. keep hasItemHoverOverlay (+ a jsdoc), drive the rest from the row's wrapper class
  // Fix: removed trackClipperClassName, the two CSS variable consts and the data-can-scroll-prev attribute. The template
  // row now styles the track from its own wrapper class. Only hasItemHoverOverlay stays on the shared carousel.
  /** Draws the grid's dark hover overlay on each item; off for items that bring their own hover, such as linked cards. */
  hasItemHoverOverlay?: boolean;
}
